import { factory, Box, omitText, Image, PhotoOverlay, Flex, Typography, DsmColor, Link } from '@kohler-dsm-library/kohler-core';
import clsx from 'clsx';
import React from 'react';
import classes from './ImageLink.module.css.mjs';

const ImageLink = factory((props, ref) => {
  const {
    CTA,
    image,
    title,
    eyebrow,
    showCTA = true,
    opacity = 35,
    gradientDirection = "bottom-top",
    position = "middle-center",
    className,
    ...rest
  } = props;
  const isMiddleCenter = position === "middle-center";
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    Box,
    {
      ref,
      component: !showCTA && CTA ? "a" : "div",
      className: clsx("kohler-image-link-card-root", classes.imageLinkCardWrapper, className),
      ...omitText(CTA),
      ...rest
    },
    /* @__PURE__ */ React.createElement(
      Box,
      {
        component: "figure",
        className: clsx(
          classes.imageLinkCardImageBackground,
          isMiddleCenter && classes.imageLinkCardImageBackgroundMiddle,
          !isMiddleCenter && classes.imageLinkCardImageBackgroundBottom
        )
      },
      /* @__PURE__ */ React.createElement(Image, { ...image, src: image.src, alt: image.alt }),
      /* @__PURE__ */ React.createElement(
        PhotoOverlay,
        {
          direction: gradientDirection,
          opacity,
          className: clsx(
            classes.imageLinkCardContentWrapper,
            isMiddleCenter ? classes.imageLinkCardContentWrapperMiddle : classes.imageLinkCardContentWrapperBottom
          )
        },
        /* @__PURE__ */ React.createElement(Flex, { direction: "column", gap: 10 }, eyebrow && !isMiddleCenter && /* @__PURE__ */ React.createElement(
          Typography,
          {
            component: eyebrow.component || "h3",
            ...omitText(eyebrow),
            textColor: DsmColor.ContentOnPhoto,
            size: "label-medium-s"
          },
          eyebrow.text
        ), title && /* @__PURE__ */ React.createElement(
          Typography,
          {
            textColor: DsmColor.ContentOnPhoto,
            size: isMiddleCenter ? "h4" : "h5",
            component: title.component || "h3",
            ...omitText(title)
          },
          title.text
        )),
        showCTA && CTA && /* @__PURE__ */ React.createElement(Link, { size: "large", ...omitText(CTA), textColor: DsmColor.ContentOnPhoto }, CTA.text)
      )
    )
  ));
});

export { ImageLink };
